import React from 'react';
import { DynamicForm } from '../DynamicForm/DynamicForm';
import { IHeadingData } from '../DynamicForm/IDynamicFormTypes';
import './SingleColumnDynamicForm.scss';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';
export interface ISingleColumnDynamicForm {
    id: string;
    theme: `white` | `gray` | `dark`;
    formHeading?: string;
    formHeadingTag?: `h1` | `h2` | `h3`;
    formSubtitle?: string;
    formElements: string;
    submissionUrl?: string;
    formDisclaimer?: string;
    formHeadingData?: IHeadingData;
    successPageUrl?: string;
}

export const SingleColumnDynamicForm = ({
    theme,
    formHeading,
    formElements,
    submissionUrl,
    id,
    formDisclaimer,
    formHeadingData,
    successPageUrl,
}: ISingleColumnDynamicForm) => {
    if (!formElements || !id) {
        return <p>Missing form elements or form ID!</p>;
    }
    return (
        <ParentNodeProvider
            nodeName={formHeading}
            nodeType="Single_Column_Dynamic_Form"
        >
            <section
                className={`themed-container c--single-column-dynamic-form ${theme}`}
            >
                <div className="kite-container">
                    <DynamicForm
                        node={formElements}
                        submissionUrl={submissionUrl}
                        dynamicFormID={id}
                        disclaimer={formDisclaimer}
                        formHeadingData={formHeadingData}
                        successPageUrl={successPageUrl}
                    ></DynamicForm>
                </div>
            </section>
        </ParentNodeProvider>
    );
};
